/**
 * 设备 ID 统一管理模块
 *
 * 确保整个应用使用一致的设备标识符，格式为 UUID v4
 */

const DEVICE_ID_KEY = 'enpass_device_id';

/** 验证 UUID v4 格式 */
function isValidUUIDv4(id: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
}

/** 生成新设备 ID（强制 UUID v4 格式） */
export function generateDeviceId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // 手动生成 UUID v4（降级方案）
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** 获取或生成设备 ID（自动迁移旧格式到 UUID v4） */
export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);

  // 如果没有 ID 或 ID 不是有效的 UUID v4，重新生成
  if (!id || !isValidUUIDv4(id)) {
    id = generateDeviceId();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }

  return id;
}

/** 设置设备 ID（用于跨设备同步，必须是 UUID v4 格式） */
export function setDeviceId(newId: string): boolean {
  if (!isValidUUIDv4(newId)) {
    console.warn('[deviceId] Invalid format, must be UUID v4');
    return false;
  }
  localStorage.setItem(DEVICE_ID_KEY, newId);
  return true;
}
